
define('text!setup/reserve-g2mm/reserve-g2mm.html',[],function () { return '<div class="gotomeet-setup reserve-g2mm">\n    <div class="container editable-container">\n        <div data-bind="compose: contentView"></div>\n    </div>\n\n    <div data-bind="compose: promoContentView"></div>\n</div>\n';});

